"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useMediaQuery = _interopRequireDefault(require("@mui/material/useMediaQuery"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _mui = require("tss-react/mui");
var _styles = require("@mui/material/styles");
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _MoreVert = _interopRequireDefault(require("@mui/icons-material/MoreVert"));
var _Divider = _interopRequireDefault(require("@mui/material/Divider"));
var _Menu = require("../Menu");
var _MobileContextMenu = _interopRequireDefault(require("../MobileContextMenu"));
var _DesktopContextMenu = _interopRequireDefault(require("../DesktopContextMenu"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _mui.makeStyles)()(function (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      zIndex: 3
    },
    iconButton: {
      position: 'absolute',
      top: theme.spacing(1),
      right: theme.spacing(1),
      padding: 0
    },
    iconButtonLight: {
      color: 'white'
    },
    label: {
      margin: theme.spacing(2),
      color: theme.palette.darkGrey.light
    },
    "default": {
      color: theme.palette.darkGrey.main
    },
    red: {
      color: theme.palette.red.main
    },
    divider: {
      margin: theme.spacing(1, 2)
    },
    overShadow: {
      color: 'grey'
    }
  };
});
var ContextMenu = function ContextMenu(props) {
  var items = props.items,
    variant = props.variant,
    iconButtonClassName = props.iconButtonClassName,
    anchorOrigin = props.anchorOrigin,
    transformOrigin = props.transformOrigin;
  var _useStyles = useStyles(),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  var theme = (0, _styles.useTheme)();
  var desktop = (0, _useMediaQuery["default"])(theme.breakpoints.up('md'), {
    noSsr: true
  });
  var anchorRef = _react["default"].useRef(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    contextMenuOpen = _useState2[0],
    setContextMenuOpen = _useState2[1];
  var handleToggle = function handleToggle(e) {
    if (e) e.stopPropagation();
    setContextMenuOpen(function (prevState) {
      return !prevState;
    });
  };
  var handleClick = function handleClick(e, onClick) {
    e.stopPropagation();
    onClick(e);
    setContextMenuOpen(false);
  };
  var ContextMenuItems = function ContextMenuItems() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, items.filter(function (_ref) {
      var hidden = _ref.hidden;
      return !hidden;
    }).map(function (itemProps) {
      return typeof itemProps !== 'string' ? /*#__PURE__*/_react["default"].createElement("div", {
        key: itemProps.name
      }, /*#__PURE__*/_react["default"].createElement(_Menu.MenuItem, {
        onClick: function onClick(e) {
          return handleClick(e, itemProps.onClick);
        },
        className: cx(classes[itemProps.color || 'default'], itemProps.disabled && classes.overShadow),
        disabled: itemProps.disabled
      }, itemProps.icon, itemProps.name)) : /*#__PURE__*/_react["default"].createElement(_Divider["default"], {
        variant: "middle",
        className: classes.divider,
        orientation: "horizontal"
      });
    }));
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    "aria-label": "menu",
    className: cx(classes.iconButton, variant === 'light' && classes.iconButtonLight, iconButtonClassName),
    onClick: function onClick(e) {
      e.stopPropagation();
      setContextMenuOpen(true);
    },
    ref: anchorRef
  }, /*#__PURE__*/_react["default"].createElement(_MoreVert["default"], null)), desktop ? /*#__PURE__*/_react["default"].createElement(_DesktopContextMenu["default"], {
    anchorOrigin: anchorOrigin,
    transformOrigin: transformOrigin,
    anchorRef: anchorRef,
    open: contextMenuOpen,
    onToggle: handleToggle
  }, /*#__PURE__*/_react["default"].createElement(ContextMenuItems, null)) : /*#__PURE__*/_react["default"].createElement(_MobileContextMenu["default"], {
    onToggle: handleToggle,
    open: contextMenuOpen
  }, /*#__PURE__*/_react["default"].createElement(ContextMenuItems, null)));
};
ContextMenu.propTypes = {
  anchorOrigin: _propTypes["default"].oneOf({
    horizontal: 'center' || 'left' || 'right',
    vertical: 'bottom' || 'center' || 'top'
  }),
  transformOrigin: _propTypes["default"].oneOf({
    horizontal: 'center' || 'left' || 'right',
    vertical: 'bottom' || 'center' || 'top'
  }),
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string,
    onClick: _propTypes["default"].func,
    color: _propTypes["default"].oneOf(['default', 'red']),
    icon: _propTypes["default"].node,
    disabled: _propTypes["default"].bool,
    divider: _propTypes["default"].bool
  })).isRequired,
  variant: _propTypes["default"].oneOf(['dark', 'light']),
  iconButtonClassName: _propTypes["default"].string
};
ContextMenu.defaultProps = {
  anchorOrigin: {
    horizontal: 'left',
    vertical: 'center'
  },
  transformOrigin: {
    horizontal: 'right',
    vertical: 'top'
  },
  variant: 'dark',
  iconButtonClassName: undefined
};
var _default = ContextMenu;
exports["default"] = _default;